import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { completeReference, getReferenceRequest } from '../../../actions/index';
import url from 'url';
import formData from 'form-serialize';
import CoWorker from './CoWorker';
import Supervisor from './Supervisor';

class Reference extends Component {
  constructor (props) {
    super(props);
    this.state = {
      referenceTokenError: false,
      completed: false
    };
  }

  componentDidMount () {
    if (window) {
      const query = url.parse(window.location.href, true).query;
      const token = query && query.token;
      if (token) {
        this.props.getReferenceRequest(token).then(data => {
          if (!data) {
            this.setRefError();
          }
        });
      } else {
        this.setRefError();
      }
    }
  }

  setRefError = () => {
    this.setState({
      referenceTokenError: true
    });
  };

  completeReference = event => {
    event.persist();
    event.preventDefault();
    const { reference_token: token } = this.props.reference;
    const data = Object.entries(formData(event.target, { hash: true }));
    const dataParsed = {};
    data.map(item => {
      dataParsed[item[0]] = parseInt(item[1], 10);
      return true;
    });
    this.props.completeReference({ token, ...dataParsed })
      .then(data => data ? this.setState({ completed: true }) : null);
  };

  render () {
    const { reference, t } = this.props;
    const { email, is_supervisor } = reference;
    const { completed, referenceTokenError } = this.state;
    if (completed) {
      return <div>{t('ref:complete')}</div>;
    }

    if (!email || referenceTokenError) {
      return (
        <div className='reference-error-message'>
          <h2>We’re sorry, the reference is already completed.</h2>
          <h3><Link className='home-link' to='/'>Go to homepage</Link></h3>
        </div>
      );
    }

    const Render = props => is_supervisor ? <Supervisor {...props} />
      : <CoWorker {...props} />;

    return <div className='row'>
      <div className='col col-12 col-md-8 col-lg-6 col-xl-5 mt-4 ml-auto mr-auto'>
        <h1>{t('ref:endorse')}</h1>
        <Render {...reference} handleSubmit={this.completeReference} />
      </div>
    </div>;
  }
}

const mapStateToProps = state => {
  return { reference: state.reference };
};

const mapDispatchToProps = {
  getReferenceRequest, completeReference
};

export default translate()(connect(mapStateToProps, mapDispatchToProps)(Reference));



// WEBPACK FOOTER //
// ./src/components/app/references/index.js